module.exports = __webpack_public_path__ + "media/images/new-transaction-9216a51be04c95365149b8a5aa48fa08.gif";